// extracted by mini-css-extract-plugin
export default {"welcomeSection":"WelcomeSection_welcomeSection__we+6A","text":"WelcomeSection_text__KAVfE"};